<template>
    <div id="dinnerState">
        <i-col span="24" style="padding: 0 20px;">
            <div class="query-bar">
                <Form class="rightTop" inline :label-width="80">
                	<h4>就餐统计</h4>
                    <Form-item label="部门名称" prop="user_department">
                        <Select  v-model="qy_department" clearable  style="width:200px">
                            <Option v-for="(item,index) in departList" :value="item" :key="index">{{ item }}</Option>
                        </Select>
                    </Form-item>
                    <Form-item label="月份" prop="stat_month">
                        <DatePicker  type="month" v-model="qy_stat_month" placeholder="月份" style="width: 200px"></DatePicker>
                    </Form-item>
                    <!-- <Form-item label="用户名称" prop="qy_realname">
                        <Input v-model="qy_realname" :maxlength="16" placeholder="请输入名称"></Input>
                    </Form-item> -->
                    <!-- <Form-item label="用户角色" prop="qy_rolename">
                        <Select v-model="qy_rolename" clearable style="width:162px">
                            <Option v-for="item in rolenameList" :value="item.rolename" :key="item.rolename">{{ item.rolename }}</Option>
                        </Select>
                    </Form-item>
                    <Form-item label="用户部门" prop="qy_department">
                        <Select v-model="qy_department" clearable style="width:162px;">
                            <Option v-for="item in departmentList" :value="item.name" :key="item.name">{{ item.name }}</Option>
                        </Select>
                    </Form-item> -->
                    <Button type="primary" @click="submitSearch(actionPage)">搜索</Button>
                    <Button type="primary" style="display: inline-block;right: 10px;margin-top: 0;margin-left: 10px;" @click="getEcxcel()">导出Excel表</Button>
                </Form>

            </div>
						<div class="center">
                <Table :data="UserData" :columns="theadArr" stripe></Table>
                <Page class="pull-right" :total="totalSize" :current="page" size="small" show-total @on-change="changePage"></Page>
            </div>
        </i-col>
    </div>
</template>

<!-- 2025-2调整：添加加餐合计金额字段-->
<script>
    export default {
        data () {
          return{
                qy_department: "",
                qy_stat_month:new Date() ,
                totalSize: 10,
                pageSize: 10,
                page: 1,
                rolenameList: [],
                actionPage: 1,
                UserData: [],
                departList:[],
                theadArr: [{
                    title: "人员姓名",
                    key: "realname"
                }, {
                    title: "早餐数量",
                    key: "breakfast_count"
                }, {
                    title: '应收早餐金额',
                    key: 'breakfast_total_price'
                }, {
                    title: '午餐数量',
                    key: 'lunch_count'
                }, {
                    title: '应收午餐金额',
                    key: 'lunch_total_price'
                }, {
                  title: '晚餐数量',
                  key: 'dinner_count'
                }, {
                  title: '应收晚餐金额',
                  key: 'dinner_total_price'
                }

                  , {
                    title: "加餐合计金额",
                    key: 'total_add_price'
                  }
                , {
                    title: "总合计金额",
                    key: 'total_price'
                }]
            }
        },
        methods:{
        	changQuery(){
        		this.submitSearch(this.actionPage)
        	},
            //到处excel表
            getEcxcel() {
                let that = this;
                let params = {};
                var depart = "";
                if(that.qy_department){
                    depart = that.qy_department;
                }
                params.data = {
                    stat_month: that.qy_stat_month.format("yyyy-MM"),
                    user_department: depart
                };
                params.url = "/sys/mealstat/statOutputExcel";
                params.token = window.localStorage.getItem("token");
                params.success = function(res) {
                    console.log(res);
                    var fileName = "就餐信息.xls";
                    var blob = new Blob([res.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'}); //application/vnd.openxmlformats-officedocument.spreadsheetml.sheet这里表示xlsx类型
                　　console.log("blod",blob);　
                    var downloadElement = document.createElement('a');
                　　var href = window.URL.createObjectURL(blob); //创建下载的链接
                　　downloadElement.href = href;
                　　downloadElement.download = fileName; //下载后文件名
                　　document.body.appendChild(downloadElement);
                　　downloadElement.click(); //点击下载
                　　document.body.removeChild(downloadElement); //下载完成移除元素
                　　window.URL.revokeObjectURL(href); //释放掉blob对象
                };
                this.ajaxGet(params);
            },
            //获取部门信息
            getDepart(){
                let params = {};
                var that= this
                params.data = {};
                params.url = "/sys/department/list";
                params.token = window.localStorage.getItem("token");
                params.success = function(res) {
                    res = res.data.result.result;
                    for(var i=0;i<res.length;i++){
                        that.departList.push(res[i].name)
                    }
                };
                this.ajaxPost(params);
            },
            submitSearch: function(page) {
                page = page == "" || page == undefined ? this.page : page;
                let that = this;
                let params = {};
                var depart = "";
                if(that.qy_department){
                    depart = that.qy_department;
                }
                params.data = {
                    page: page,
                    pageSize: this.pageSize,
                    order: { _id: -1 },
                    stat_month: that.qy_stat_month.format("yyyy-MM"),
                    user_department: depart
                };
                params.url = "/sys/mealstat/statdepartment";
                params.token = window.localStorage.getItem("token");
                console.log(params.data);
                params.success = function(res) {
                    console.log(res);
                    res = res.data;
                    that.UserData = res.result.result;
                    that.totalSize = res.result.totalSize;
                    that.page = res.result.page;
                };
                this.ajaxPost(params);
            },
            changePage: function(page) {
                this.submitSearch(page);
                this.actionPage = page;
            }
        },
        mounted: function() {
            this.submitSearch(this.page);
            this.getDepart();
        }
    }
</script>

<style lang="less">
    #dinnerState {

        .addBtn{
            margin-top: 5px;
            margin-bottom: 5px;
        }
        .ml32{
            height: 36px;
            line-height: 36px;
        }
        .ivu-form-item {
            margin-bottom: 0px;
        }
        .query-bar{
    		background: transparent;
    		height: 80px;
    		padding-top: 20px;
    		margin-bottom: 30px;
    		border-bottom: 1px solid #e9eaec;
    	}
    	table{
    		text-align: center;
    		th{
    			height: 50px;
    			font-size: 16px;
    		}
    		th,td{
    			text-align: center;
    		}
    	}
    	.ivu-page{
	    	margin-top: 30px;
	    }
    	.rightTop{
    		h4{
    			font-size: 18px;
    			color: #45AAF9;
    			float: left;
    			text-align: left;
    		}
    		text-align: left;
    		.ivu-form-item{
    			text-align: left;
    		}
    	}

    }
    .width90{
        width: 90%!important;
    }
    .user_msg{
        .demo-upload-list{
            display: inline-block;
            width: 60px;
            height: 60px;
            text-align: center;
            line-height: 60px;
            border: 1px solid transparent;
            border-radius: 4px;
            overflow: hidden;
            background: #fff;
            position: relative;
            box-shadow: 0 1px 1px rgba(0,0,0,.2);
            margin-right: 4px;
        }
        .demo-upload-list img{
            width: 100%;
            height: 100%;
        }
        .demo-upload-list-cover{
            display: none;
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            background: rgba(0,0,0,.6);
        }
        .demo-upload-list:hover .demo-upload-list-cover{
            display: block;
        }
        .demo-upload-list-cover i{
            color: #fff;
            font-size: 20px;
            cursor: pointer;
            margin: 0 2px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/dinnerMana/dinnerState.vue